import { Seo } from "@/lib/seo";
import { useContent } from "@/context/ContentContext";
import { AlertTriangle, Download } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const MAP = {
  mentions: { key: "mentions", title: "Mentions légales" },
  confidentialite: { key: "confidentialite", title: "Politique de confidentialité" },
  "cgv-traiteur": { key: "cgv_traiteur", title: "CGV Traiteur" },
  "cgv-coordination": { key: "cgv_coordination", title: "CGV Coordination événementielle" },
  "cgv-cheffe": { key: "cgv_chef", title: "Conditions — Cheffe à domicile" },
};

export default function Legal({ page }) {
  const { content } = useContent();
  const meta = MAP[page];
  const text = content?.legal?.[meta.key] || "";
  const file = content?.legal_files?.[meta.key];
  const isTodo = text.startsWith("À COMPLÉTER");

  return (
    <div className="min-h-screen bg-[#FAF6EF] pt-28" data-testid={`legal-${page}`}>
      <Seo title={`${meta.title} — Afro Regal`} description={meta.title} />
      <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8">
        <h1 className="font-serif text-4xl font-500 text-[#2C2C2C]">{meta.title}</h1>
        {isTodo && (
          <div className="mt-6 flex items-start gap-3 rounded-xl border border-[#C9A84C]/50 bg-white p-4 text-sm text-[#2C2C2C]/75">
            <AlertTriangle size={18} className="mt-0.5 shrink-0 text-[#C9A84C]" />
            <span>Ce document est à compléter et à vérifier avant la mise en ligne. Il est modifiable depuis l'administration.</span>
          </div>
        )}
        <div className="mt-8 whitespace-pre-wrap text-base leading-relaxed text-[#2C2C2C]/80" data-testid="legal-summary">{text}</div>
        {file?.url && (
          <a href={mediaUrl(file.url)} target="_blank" rel="noreferrer" download={file.name} data-testid="legal-download-pdf" className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#2C2C2C] px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-[#C9A84C] hover:text-[#2C2C2C]">
            <Download size={16} /> Télécharger le document complet en PDF
          </a>
        )}
      </div>
    </div>
  );
}
